import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("erfKF"), parcelRequire.load("8Jf43"), parcelRequire.load("9wnLi"), parcelRequire.load("aQuwV"), parcelRequire.load("dY2Rk"), parcelRequire.load("6Lk8i"), parcelRequire.load("hVSpU")]).then(() => {
  return Promise.all([waitForCSS("/reactspectrum/60911cde55ae4daa9375c5df6296a6d93bc1093b/s2-docs/pages.9cb5e405.css")]);
}).then(() => {
let originalModule = parcelRequire("fxMzH");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("erfKF")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8Jf43")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("9wnLi")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aQuwV")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dY2Rk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6Lk8i")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hVSpU")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
